
export const CONFIG = Object.freeze({
    TINYMCE_OPTIONS: {
        height: 300,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
        ],
        language: 'cs',
        language_url: '/assets/tinymce/langs/cs.js',
        images_dataimg_filter: function(img) {
            return false;
        }
    }
});


// WEBPACK FOOTER //
// /app/src/config.ts